
import { Route, Routes, Navigate } from 'react-router-dom';
import Index from './pages';
import DetailsThree from './pages/portfolio-detail-three';
import LiveSites from './pages/livesites';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Index/>}/>       
        <Route path='/portfolio-detail-three' element={<DetailsThree/>}/>
        <Route path='/portfolio-detail-three' element={<DetailsThree/>}/>
        <Route path='/live-websites' element={<LiveSites/>}/>
        
        {/* Catch-all route for non-existent paths */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </div>
  );
}

export default App;
